import './bm-promo.less';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	intl: PropTypes.func
};

const AppPromo = () => (
	<div>
	</div>
);

AppPromo.propTypes = propTypes;
export default AppPromo;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/dashboard/components/bm-promo.js